import ErrorBoundary from 'shared/components/ErrorBoundary';
import PropTypes from 'prop-types';
import React from 'react';
import { withTheme } from '@material-ui/core/styles';
import styles from './styles.css';

const VendorName = props => {
	const { theme, vendorName } = props;

	return vendorName !== undefined ? (
		<ErrorBoundary>
			<div className={styles['product-spacer']}>
				By{' '}
				<div
					style={{
						color: theme.palette.text.secondary,
						display: 'inline-block',
					}}
				>
					<b>{vendorName}</b>
				</div>
			</div>
		</ErrorBoundary>
	) : null;
};

VendorName.defaultProps = {
	vendorName: undefined,
};

VendorName.propTypes = {
	theme: PropTypes.instanceOf(Object).isRequired,
	vendorName: PropTypes.string,
};

export default withTheme(VendorName);
